"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const helpers_1 = require("../../lib/helpers");
const Icon_1 = __importDefault(require("../Util/Icon"));
const Journey_1 = require("../../lib/Journey");
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const useAddToForwardRef_1 = require("../../hocs/useAddToForwardRef");
const onChangeDefaultCb = () => {
    /* Because we use the checked value, we must have a onChange hook, this is a react requirement. */
    /* We used to use "defaultChecked" but I think its more intuitive for end usage to assume "checked" will work. */
};
const Checkbox = (props) => {
    var _a;
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    primitiveProps.className = classnames_1.default(primitiveProps.className, props.checked ? 'on' : 'off');
    const onChange = (_a = props.onChange) !== null && _a !== void 0 ? _a : onChangeDefaultCb;
    const inputRef = react_1.useRef(null);
    const forwardRef = useAddToForwardRef_1.useAddToForwardRef(props, [inputRef]);
    /* Table component checkbox needs click on top level. */
    const onClickForward = react_1.useCallback(() => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }, []);
    return (
    // eslint-disable-next-line
    react_1.default.createElement("div", { className: primitiveProps.className, onClick: onClickForward },
        react_1.default.createElement("input", Object.assign({ type: "checkbox" }, primitiveProps, { ref: forwardRef, onChange: onChange, value: props.checked ? props.uncheckedValue : props.checkedValue, 
            /* Due to no onChanged value, we have to use defaultChecked and not checked. */
            checked: props.checked })),
        props.checked ? react_1.default.createElement(Icon_1.default, { src: Journey_1.Journey.icons().CHECK }) : null));
};
exports.default = withJourney_1.default('j-checkbox', Checkbox);
